import { render, staticRenderFns } from "./FillSplitButton.vue?vue&type=template&id=06199448&scoped=true"
import script from "./FillSplitButton.vue?vue&type=script&lang=js"
export * from "./FillSplitButton.vue?vue&type=script&lang=js"
import style0 from "./FillSplitButton.vue?vue&type=style&index=0&id=06199448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06199448",
  null
  
)

export default component.exports